export default {
  getStatuses (state) {
    return state.statuses
  },
  getRoles (state) {
    return state.roles.filter(item => { return item.isVisible === true })
  },
  getRoleById (state) {
    return id => state.roles.find(item => { return item.id === id })
  },
  getRoleByName (state) {
    return name => state.roles.find(item => { return item.name === name })
  },
  getSubscriptionPlans (state) {
    return state.plans.filter(item => { return item.type === 'SUBSCRIPTION' && item.isVisible })
  },
  getDiyPlans (state) {
    return state.plans.filter(item => { return item.type === 'DIY' })
  },
  getPlanById (state) {
    return id => state.plans.find(item => { return item.id === id })
  },
  getPlanByUuid (state) {
    return uuid => state.plans.find(item => { return item.uuid === uuid })
  },
  getPlanNameByUuid (state) {
    return uuid => state.plans.find(item => { return item.uuid === uuid }).name
  },
  getOrganizations (state) {
    return state.organizations
  },
  getUserOrganization (state) {
    return state.userOrganization
  },
  getSelectedOrganizationId (state) {
    return state.userOrganization.id
  },
  getSelectedProjectId (state) {
    return state.selectedProjectId
  },
  getProjectsDisplay (state) {
    return state.projectsDisplay
  },
  getDisplayOwnProjects (state) {
    return state.displayOwnProjects
  },
  getProjectCategories (state) {
    return state.projectCategories
  },
  getCategorySymbols (state) {
    return state.categorySymbols
  },
  getLoginState (state) {
    return state.loginState
  },
  getRequestedProjects (state) {
    return state.requestedProjects
  },
  getNewUserUuid (state) {
    return state.newUserUuid
  },
  getBreadcrumbs (state) {
    return state.breadcrumbs
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js